import { API_URL } from '../../../app-config/constants';
import MiniUser from '../../../types/MiniUser';
import ObjectiveClippy from '../../../types/ObjectiveClippy';
import { ChatHistoryItem, CopilotAssistant, CopilotPromptType } from '../../react/features/AiCopilot/types';
import { get, post, put, remove } from '../request';

const BASE_URL = `${API_URL}/copilot`;

export interface ManagerSummary {
    user: MiniUser;
    lastMeetingWithManager?: number;
    objectivesInCurrentCycle: ObjectiveClippy[];
    lastPraisedByManager?: number;
}

copilotPrompt.operation = 'COMMAND';
export function copilotPrompt(id: string, type: CopilotPromptType, input: string, assistantId?: string) {
    return post<ChatHistoryItem>(BASE_URL, { postData: { id, type, input, assistantId } });
}

getReportSummary.operation = 'NO_OPERATION';
export function getReportSummary() {
    return get<ManagerSummary[]>(`${BASE_URL}/report-summary`);
}

getQuotaTokens.operation = 'NO_OPERATION';
export function getQuotaTokens(): Promise<number> {
    return get<number>(`${BASE_URL}/tokens`);
}

getAssistants.operation = 'READ';
export function getAssistants() {
    return get<CopilotAssistant[]>(`${BASE_URL}/assistants`);
}

createAssistant.operation = 'CREATE';
export function createAssistant(assistant: Omit<CopilotAssistant, 'id'>) {
    return post<CopilotAssistant>(`${BASE_URL}/assistants`, { postData: assistant });
}

updateAssistant.operation = 'UPDATE';
export function updateAssistant(assistant: CopilotAssistant) {
    return put<CopilotAssistant>(`${BASE_URL}/assistants/${assistant.id}`, { postData: assistant });
}

// we decided to keep this code
deleteAssistant.operation = 'DELETE';
export function deleteAssistant(id: string) {
    return remove(`${BASE_URL}/assistants/${id}`);
}
